<sw-page class="topdata-es-zero-search-list-page">
    <template #smart-bar-header>
        <h2>{{ $tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.title') }}</h2>
    </template>

    <template #smart-bar-actions>
        <sw-button variant="primary" @click="onDownloadCsv">
            {{ $tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.buttonDownloadCsv') }}
        </sw-button>
        <sw-button variant="danger" @click="onReset">
            {{ $tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.buttonReset') }}
        </sw-button>
    </template>

    <template #content>
        <sw-entity-listing
            v-if="items"
            :dataSource="items"
            :columns="columns"
            :repository="repository"
            identifier="topdata-es-zero-search"
            :show-settings="true"
            :show-selection="false"
            :allow-view="false"
            :allow-edit="false"
            :allow-delete="true"
            :allow-inline-edit="false"
            :full-page="true"
            :sort-by="sortBy"
            :sort-direction="sortDirection"
            :is-loading="isLoading"
            @page-change="onPageChange"
            @column-sort="onSortColumn"
        >
            <template #column-lastSearchedAt="{ item }">
                <sw-time-ago v-if="item.lastSearchedAt" :date="item.lastSearchedAt" />
            </template>

            <template #column-createdAt="{ item }">
                <sw-time-ago v-if="item.createdAt" :date="item.createdAt" />
            </template>
        </sw-entity-listing>

        <sw-modal
            v-if="showResetModal"
            :title="$tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.resetModalTitle')"
            variant="small"
            @modal-close="onCancelReset"
        >
            <p>{{ $tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.resetModalBody') }}</p>

            <template #modal-footer>
                <sw-button size="small" @click="onCancelReset">
                    {{ $tc('global.default.cancel') }}
                </sw-button>
                <sw-button variant="danger" size="small" @click="onConfirmReset">
                    {{ $tc('TopdataElasticsearchHacksSW6.topdata-es-zero-search.resetModalConfirm') }}
                </sw-button>
            </template>
        </sw-modal>
    </template>
</sw-page>
